import { Module } from "wrapper6";
import { toggleClass, hasClass, removeClass, addClass } from "../utils/_class-handlers";

var $ = jQuery;

export default class SocialShare extends Module {

	ready(app) {

        // Get all social share icons
        const SOCIAL_ICONS = document.querySelectorAll('a.social-icon');

        // networks setup
        const NETWORKS = {
            facebook: { width: 600, height: 300 },
            twitter: { width: 600, height: 254 },
            google: { width: 515, height: 490 },
            linkedin: { width: 600, height: 473 }
        };

        if (SOCIAL_ICONS.length > 0) {

            for (let i = 0; i < SOCIAL_ICONS.length; i++) {

                const ICON = SOCIAL_ICONS[i];

                ICON.addEventListener('click', function(e) {

                    e.preventDefault();

                    // get attributes
                    let href = ICON.getAttribute('href');
                    let network = ICON.getAttribute('data-network');

                    popup(href, network);
                });
            }
        }

        function popup(href, network) {
            let options = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,';
            window.open(href, '', options + 'height=' + NETWORKS[network].height + ',width=' + NETWORKS[network].width);
        };

        /**
         * Bookmark
         */
        var triggerBookmark = $(".js-bookmark"); // It must be an `a` tag

        triggerBookmark.click(function() {
            
            if (window.sidebar && window.sidebar.addPanel) { // Firefox <23
                
                window.sidebar.addPanel(document.title,window.location.href,'');

            } else if(window.external && ('AddFavorite' in window.external)) { // Internet Explorer

                window.external.AddFavorite(location.href,document.title); 

            } else if(window.opera && window.print || window.sidebar && ! (window.sidebar instanceof Node)) { // Opera <15 and Firefox >23
                /**
                 * For Firefox <23 and Opera <15, no need for JS to add to bookmarks
                 * The only thing needed is a `title` and a `rel="sidebar"`
                 * To ensure that the bookmarked URL doesn't have a complementary `#` from our trigger's href
                 * we force the current URL
                 */
                triggerBookmark.attr('rel', 'sidebar').attr('title', document.title).attr('href', window.location.href);
                return true;
            
            } else { // For the other browsers (mainly WebKit) we use a simple alert to inform users that they can add to bookmarks with ctrl+D/cmd+D
                
                alert('Du kan tilføje bogmærket ved at trykke ' + (navigator.userAgent.toLowerCase().indexOf('mac') != - 1 ? 'Command/Cmd' : 'CTRL') + ' + D på dit keyboard.');
            
            }
            // If you have something in the `href` of your trigger
            return false;
        });
    }
}